import { createSlice } from "@reduxjs/toolkit";
import { binUpload, createNewCardio, registerRentalDevice, getRentalUsersList, getRentalUsersDetails, getUnregisteredDevicesList, generatePayout, releasePayout, getPayoutList } from "../actions/bin_action";

const binUploadSlice = createSlice({
  name: "binUpload",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(binUpload.pending, (state) => {
        console.log("loaadingslice1");
        state.loading = true;
        state.error = null;
      })
      .addCase(binUpload.fulfilled, (state, action) => {
        console.log("loaading");
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(binUpload.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const createNewCardioSlice = createSlice({
  name: "createNewCardio",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createNewCardio.pending, (state) => {
        console.log("loaadingslice1");
        state.loading = true;
        state.error = null;
      })
      .addCase(createNewCardio.fulfilled, (state, action) => {
        console.log("loaading");
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(createNewCardio.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const registerRentalDeviceSlice = createSlice({
  name: "registerRentalDevice",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(registerRentalDevice.pending, (state) => {
        console.log("loaadingslice1");
        state.loading = true;
        state.error = null;
      })
      .addCase(registerRentalDevice.fulfilled, (state, action) => {
        console.log("loaading");
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(registerRentalDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const getRentalUsersListSlice = createSlice({
  name: "getRentalUsersList",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRentalUsersList.pending, (state) => {
        console.log("loaadingslice1");
        state.loading = true;
        state.error = null;
      })
      .addCase(getRentalUsersList.fulfilled, (state, action) => {
        console.log("loaading");
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(getRentalUsersList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const getRentalUsersDetailsSlice = createSlice({
  name: "getRentalUsersDetails",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRentalUsersDetails.pending, (state) => {
        console.log("loaadingslice1");
        state.loading = true;
        state.error = null;
      })
      .addCase(getRentalUsersDetails.fulfilled, (state, action) => {
        console.log("loaading");
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(getRentalUsersDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const getUnregisteredDevicesListSlice = createSlice({
  name: "getUnregisteredDevicesList",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUnregisteredDevicesList.pending, (state) => {
        console.log("loaadingslice1");
        state.loading = true;
        state.error = null;
      })
      .addCase(getUnregisteredDevicesList.fulfilled, (state, action) => {
        console.log("loaading");
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(getUnregisteredDevicesList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const generatePayoutSlice = createSlice({
  name: "generatePayout",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(generatePayout.pending, (state) => {
        console.log("loaadingslice1");
        state.loading = true;
        state.error = null;
      })
      .addCase(generatePayout.fulfilled, (state, action) => {
        console.log("loaading");
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(generatePayout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const releasePayoutSlice = createSlice({
  name: "releasePayout",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(releasePayout.pending, (state) => {
        console.log("loaadingslice1");
        state.loading = true;
        state.error = null;
      })
      .addCase(releasePayout.fulfilled, (state, action) => {
        console.log("loaading");
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(releasePayout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const getPayoutListSlice = createSlice({
  name: "getPayoutList",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPayoutList.pending, (state) => {
        console.log("loaadingslice1");
        state.loading = true;
        state.error = null;
      })
      .addCase(getPayoutList.fulfilled, (state, action) => {
        console.log("loaading");
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(getPayoutList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

export const reducers = {
  binUpload: binUploadSlice.reducer,
  createNewCardio: createNewCardioSlice.reducer,
  registerRentalDevice: registerRentalDeviceSlice.reducer,
  getRentalUsersList: getRentalUsersListSlice.reducer,
  getRentalUsersDetails: getRentalUsersDetailsSlice.reducer,
  getUnregisteredDevicesList: getUnregisteredDevicesListSlice.reducer,
  generatePayout: generatePayoutSlice.reducer,
  releasePayout: releasePayoutSlice.reducer,
  getPayoutList: getPayoutListSlice.reducer,
};
